import { fieldDetailsData } from '@/app/model/store/domain/types'
/* LocalStorage */
class Local {
  /* flag */
  public setReminderFlag (flag: boolean) {
    localStorage.setItem('reminderFlag', JSON.stringify(flag))
  }
  public getReminderFlag () {
    return localStorage.getItem('reminderFlag')
  }

  public setResettingFlag (flag: boolean) {
    localStorage.setItem('resettingFlag', JSON.stringify(flag))
  }
  public getResettingFlag () {
    return localStorage.getItem('resettingFlag')
  }

  /* user */
  public setAuthToken (id: string) {
    localStorage.setItem('authToken', id)
  }
  public getAuthToken () {
    return localStorage.getItem('authToken')
  }

  public setUserName (name: string) {
    localStorage.setItem('userName', name)
  }
  public getUserName () {
    return localStorage.getItem('userName')
  }

  public setUserType (type: string) {
    localStorage.setItem('userType', type)
  }
  public getUserType () {
    return localStorage.getItem('userType')
  }

  /* select box */
  // 品種セレクトボックスを構成するためのデータ
  public setVarietiesData (varieties: string) {
    localStorage.setItem('varietiesData', varieties)
  }
  public getVarietiesData () {
    return localStorage.getItem('varietiesData')
  }

  // グレードセレクトボックスを構成するためのデータ
  public setGradeData (grade: string) {
    localStorage.setItem('gradeData', grade)
  }
  public getGradeData () {
    return localStorage.getItem('gradeData')
  }

  // ステータスセレクトボックスを構成するためのデータ
  public setGrowthStageData (growth: string) {
    localStorage.setItem('growthStageData', growth)
  }
  public getGrowthStageData () {
    return localStorage.getItem('growthStageData')
  }

  /* Storage削除 */
  public clear () {
    localStorage.clear()
  }
}
export default new Local()
